import React, { /* useContext,  */useEffect } from 'react'
import { Rect, Circle, Text, Group, Transformer } from 'react-konva'
import { getContrastColor } from '../../helpers'

const Table = ({ shapeProps, isSelected, onSelect, onChange, onContextMenu, grid }) => {
	const shapeRef = React.useRef()
	const trRef = React.useRef()

	useEffect(() => {
		if (isSelected) {
		// we need to attach transformer manually
			trRef.current.nodes([shapeRef.current])
			trRef.current.getLayer().batchDraw()
		}
	}, [isSelected])

	const textHeight = shapeProps.shape === 'round' ? 0 : shapeProps.height
	const textOffsetX = shapeProps.shape === 'round' ? shapeProps.width / 2 : 0
	return (
		<>
			<Group
				x={shapeProps.positionLeft}
				y={shapeProps.positionTop}
				width={shapeProps.width}
				height={shapeProps.height}
				draggable
				onClick={onSelect}
				onTap={onSelect}
				ref={shapeRef}
				onContextMenu={onContextMenu}
				onDragEnd={(e) => {
					const x = getPositionValue(e, 'x', grid, shapeProps)
					const y = getPositionValue(e, 'y', grid, shapeProps)
					e.target.to({ x, y })
					onChange({
						...shapeProps,
						positionLeft: x,
						positionTop: y
					})
				}}
				onTransformEnd={(e) => {
					// transformer is changing scale of the node
					// and NOT its width or height
					// but in the store we have only width and height
					// to match the data better we will reset scale on transform end

					const node = shapeRef.current
					const scaleX = node.scaleX()
					const scaleY = node.scaleY()

					// we will reset it back
					node.scaleX(1)
					node.scaleY(1)

					let width = node.width()
					let height = node.height()

					onChange({
						...shapeProps,
						positionLeft: node.x(),
						positionTop: node.y(),
						// set minimal value
						width: Math.max(5, width * scaleX),
						height: Math.max(5, height * scaleY)
					})
				}}
			>
				{['square', 'rectangle'].includes(shapeProps.shape) &&
					<Rect
						width={shapeProps.width}
						height={shapeProps.height}
						fill={shapeProps.componentColor || '#fff'}
						cornerRadius={2}
						// stroke={shapeProps.componentColor}
						stroke='#434343'
						strokeWidth={2}
					/>}
				{shapeProps.shape === 'round' &&
					<Circle
						radius={shapeProps.width / 2}
						fill={shapeProps.componentColor || '#fff'}
						stroke='#434343'
						strokeWidth={2}
					/>}
				<Text
					width={shapeProps.width}
					height={textHeight}
					offsetX={textOffsetX}
					text={shapeProps.caption}
					align='center'
					verticalAlign='middle'
					// fontSize={shapeProps.height / 10}
					fill={getContrastColor(shapeProps.componentColor || 'fff')}
				/>
			</Group>
			{isSelected && (
				<Transformer
					ref={trRef}
					rotateEnabled={false}
					boundBoxFunc={(oldBox, newBox) => {
						// limit resize
						if (newBox.width < 15 || newBox.height < 15) {
							return oldBox
						}
						if ((shapeProps.shape === 'round') && (newBox.height !== newBox.width)) {
							return oldBox
						}
						return newBox
					}}
				/>
			)}
		</>
	)
}

export default Table

const getPositionValue = (e, value, grid, shapeProps) => {
	switch(shapeProps.shape) {
		case 'round':
			if (e.target[value]() < (shapeProps.width / 2)) {
				return shapeProps.width / 2
			}
			return Math.round(e.target[value]() / grid) * grid
		default:
			const res = Math.round(e.target[value]() / grid) * grid
			if (res < (grid / 2)) {
				return 0
			}
			return res
	}
}
